<mat-icon *ngIf="!shake"
  color="primary"
  [ngClass]="{'animate' : animate}" 
  [ngStyle]="{'font-size': size+'px', 'width': size +'px', 'height': size+'px',  'color': !animate ? (colorEnd=='primary'?'currentColor':colorEnd) : (colorStart=='primary'?'currentColor':colorStart) , 'cursor':pointer?'pointer':null}"
  (click)="toggle()">{{animate ? end : start}}
  
</mat-icon>

<div [matBadgeSize]="badgeSize" [matBadge]="badgeLength" [matBadgeHidden]="badgeHidden"   [matBadgeColor]="badgeColor">
  <mat-icon *ngIf="shake"  color="primary"
    [ngClass]="{'shake' : doShake}" >{{start}}
  </mat-icon>
</div>